//fetch participants
export const getAll = async (filters) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URI}/participants/all`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
        body: JSON.stringify(filters),
      }
    );
    const data = await res.json();
    return data;
  } catch (e) {
    throw new Error(e);
  }
};

// fetch all parts v2
export const getParts = async (id, query) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URI}/participants/${id}/?${query}`
    );

    if (!res.ok) throw new Error();
    const data = await res.json();
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

//delete one participant
export const deleteParticipant = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URI}/participants/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      }
    );

    const data = await res.json();

    if (res.status !== 200 || !res.ok) throw new Error();
    else return data;
  } catch (error) {
    throw new Error(error);
  }
};

//delete many participants
export const deleteMany = async (eventId, participants) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URI}/participants`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify({ eventId: eventId, parts: participants }),
    });

    const data = await res.json();

    if (res.status !== 200 || !res.ok) throw new Error();
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

//edit participant
export const editParticipant = async (participant, id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URI}/participants/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
        body: JSON.stringify(participant),
      }
    );

    const data = res.json();
    if (res.ok) return data;
  } catch (e) {
    throw new Error(e);
  }
};

export const editPart = async (part, id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URI}/participants/update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
        body: JSON.stringify(part),
      }
    );

    const data = res.json();
    if (res.status !== 200 || !res.ok) throw new Error();
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

export const updatePart = async() => {
  
}